import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=c7d31290&scoped=true&"
import script from "./NotificationDropdown.vue?vue&type=script&lang=ts&"
export * from "./NotificationDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationDropdown.vue?vue&type=style&index=0&id=c7d31290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d31290",
  null
  
)

export default component.exports